// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"350":"7ba05c83","624":"070938e4","632":"c73887b9","785":"7dad2148","866":"9820da79"}[chunkId] + ".css";
};